export default {
  data() {
    return {
      currentPage: 1,
      pagination: {
        totalItems: 0,
        itemsByPage: 10,
      },
    }
  },
  methods: {
    initPagination(currentPage, totalItems, itemsByPage) {
      this.currentPage = currentPage ?? 1
      this.pagination.totalItems = totalItems ?? 0
      this.pagination.itemsByPage = itemsByPage ?? 10
    },
    getPaginationSettings() {
      return {
        currentPage: this.currentPage,
        totalItems: this.pagination.totalItems,
        itemsByPage: this.pagination.itemsByPage,
      }
    },
  },
}
